import { render, staticRenderFns } from "./OutingDocumentBody.vue?vue&type=template&id=19354eca"
import script from "./OutingDocumentBody.vue?vue&type=script&lang=js"
export * from "./OutingDocumentBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports